import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function WelcomePage(): JSX.Element {
  return (
    <div className="mx-auto max-w-3xl">
      <header className="mb-10">
        <span className="font-mono text-[11px] uppercase tracking-wider text-muted-2">
          Workspace
        </span>
        <h1 className="mt-2 text-[36px] font-bold leading-tight tracking-[-0.025em] text-ink">
          Bem-vindo ao Control Center.
        </h1>
        <p className="mt-3 max-w-[560px] text-[14px] leading-[1.5] text-muted">
          Onde você vende, cobra, fiscaliza e acompanha todos os produtos da{' '}
          <em className="font-serif italic text-brand">Owl.</em>
        </p>
      </header>

      <section className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <div className="rounded-[14px] border border-line bg-panel p-[18px]">
          <span className="text-[11px] font-medium uppercase tracking-wider text-muted-3">
            Próximos passos
          </span>
          <ul className="mt-3 space-y-[6px] text-[13px] text-ink-2">
            <li>— Cadastrar primeiros clientes</li>
            <li>— Criar planos comerciais</li>
            <li>— Conectar SaaS via bootstrap</li>
          </ul>
          <Link
            to="/dashboard"
            className="mt-5 inline-flex items-center gap-1 text-[12px] font-medium text-ink transition-colors hover:text-ink-2"
          >
            Ir para o dashboard
            <ArrowRight size={13} strokeWidth={2} />
          </Link>
        </div>

        <div className="rounded-[14px] border border-line bg-panel p-[18px]">
          <span className="text-[11px] font-medium uppercase tracking-wider text-muted-3">
            Stack
          </span>
          <p className="mt-3 text-[13px] text-ink-2">
            NestJS · Prisma · Postgres 16 · BullMQ · React 18 · Vite · Tailwind · shadcn/ui
          </p>
        </div>
      </section>
    </div>
  );
}
